import React, { type ElementProps } from "react";
import classNames from "classnames";
import { Label } from "reactstrap";
import Icon from "@components/icon";
import TooltipDropdown from "@components/tooltip-dropdown";
import { RJSFSchema, UiSchema } from "@rjsf/utils";
type LabelProps = $Exact<{
  ...Props,
  label: string,
  schema: RJSFSchema,
  uiSchema: UiSchema,
}>;

const LabelTemplate = (props: LabelProps) => {
  const { schema, uiSchema } = props;
  const uiOptions = (uiSchema && uiSchema["ui:options"]) || {};
  let label = props.label || schema.title || schema.id;
  const tooltip = { ...uiOptions?.tooltip, title: label };

  if (uiOptions.label) label = uiOptions.label;

  const labelEl = (
    <Label
      for={props.id}
      htmlFor={props.id}
      name="label-template"
      className={classNames("p-0 m-0 d-flex align-items-center", props.className)}
    >
      {label}
    </Label>
  );
  return labelEl;
  // return tooltip ? (
  //   <TooltipDropdown target={props.id} {...tooltip}>
  //     {labelEl}
  //   </TooltipDropdown>
  // ) : (
  //   labelEl
  // );
};
export default LabelTemplate;
